export const a = 1;

export const YEN_INCOM_TAX_PER = 0.1;

// process.env.NODE_ENV: "development"
export const BASE_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://gloveworks.net";
export const WWW_URL = process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://www.gloveworks.net";
export const KR_URL = process.env.NODE_ENV === "development" ? "http://localhost:3001" : "https://kr.gloveworks.net";
export const JP_URL = process.env.NODE_ENV === "development" ? "http://localhost:3002" : "https://jp.gloveworks.net";
export const EN_URL = process.env.NODE_ENV === "development" ? "http://localhost:3003" : "https://en.gloveworks.net";